// IMPORT PACKAGES

import React from 'react';
import { Provider } from 'react-redux';
import { AuthenticationService } from '../Services/AuthenticationService';
import { PersistGate } from 'redux-persist/integration/react';

// IMPORT STORE

import { createAppStore } from '../Components/State/Stores/AppStore';

// IMPORT COMPONENTS

import { AppRouter } from './Routers/AppRouter';

const redux = createAppStore();

// COMPONENT
export class App extends React.Component {

    componentDidMount() {
        AuthenticationService();
    }

    render() {
        return (
            <Provider store={redux.store}>
                <PersistGate loading={null} persistor={redux.persistor}>
                    <AppRouter />
                </PersistGate>
            </Provider>
        );
    }
}
